import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import {
  isSearchOtherItem,
  isSearchPlotItem,
  isSearchPointItem,
  MapboxResult,
  SearchOtherItem,
  SearchPlotItem,
  SearchPointItem,
  SearchResult,
  SearchService,
} from './search.service';

@Injectable({
  providedIn: 'root',
})
export class SearchMapIntegrationService implements OnDestroy {
  private searchService = inject(SearchService);

  public isSearchVisible$ = new BehaviorSubject<boolean>(false);
  private _mapFlyToPosition$ = new Subject<SearchResult<SearchPointItem>>();
  public mapFlyToPosition$ = this._mapFlyToPosition$.asObservable();

  private _mapFlyToPolygon$ = new Subject<SearchResult<SearchPlotItem>>();
  public mapFlyToPolygon$ = this._mapFlyToPolygon$.asObservable();

  private _mapFlyToArea$ = new Subject<SearchResult<SearchOtherItem>>();
  public mapFlyToArea$ = this._mapFlyToArea$.asObservable();

  public _searchItemClicked$ = new Subject<void>();
  public searchItemClicked$ = this._searchItemClicked$.asObservable();

  private _mapFlyToPoint$ = new Subject<[number, number]>();
  public mapFlyToPoint$ = this._mapFlyToPoint$.asObservable();

  public requestFlyToMapboxItem(item: MapboxResult) {
    const c = item?.center;
    if (
      Array.isArray(c) &&
      c.length >= 2 &&
      Number.isFinite(c[0]) &&
      Number.isFinite(c[1])
    ) {
      this._mapFlyToPoint$.next([c[0], c[1]]);
      return;
    }

    const mapboxId = String(item?.id ?? '').trim();
    const sessionToken =
      typeof item.sessionToken === 'string' ? item.sessionToken.trim() : '';
    if (mapboxId && sessionToken) {
      this.searchService
        .retrieveMapboxSuggestionLngLat(mapboxId, sessionToken)
        .pipe(
          take(1),
          filter((lngLat): lngLat is [number, number] => lngLat !== null),
        )
        .subscribe({
          next: (lngLat) => this._mapFlyToPoint$.next(lngLat),
        });
    }
  }
  public requestFlyToToSearchItem(item: SearchResult<SearchPointItem | SearchPlotItem | SearchOtherItem>) {
    this._searchItemClicked$.next();
    if (isSearchPointItem(item.data)) {
      this._mapFlyToPosition$.next(item as SearchResult<SearchPointItem>);
      return;
    }

    if (isSearchPlotItem(item.data)) {
      this._mapFlyToPolygon$.next(item as SearchResult<SearchPlotItem>);
    }

    if (isSearchOtherItem(item.data)) {
      const data = item as SearchResult<SearchOtherItem>;

      this._mapFlyToArea$.next(data);
    }
  }

  public toggleSearchVisibility() {
    this.isSearchVisible$.next(!this.isSearchVisible$.getValue());
  }

  public setSearchVisibility(isOpen: boolean) {
    this.isSearchVisible$.next(isOpen);
  }
  ngOnDestroy() {
    this._mapFlyToPosition$.complete();
    this._mapFlyToPolygon$.complete();
    this._mapFlyToArea$.complete();
    this._mapFlyToPoint$.complete();
    this._searchItemClicked$.complete();
  }
}
